import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./index.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { topicPages } from "./pages/topicPages";

import reportWebVitals from "./reportWebVitals";

const AboutDossier = lazy(() => import("./pages/AboutDossier"));
const FullComplaint = lazy(() => import("./pages/FullComplaint"));
const Home = lazy(() => import("./pages/Home"));
const Resources = lazy(() => import("./pages/Resources"));
const Search = lazy(() => import("./pages/Search"));
const NotFound = lazy(() => import("./pages/NotFound"));
const TopicPage = lazy(() => import("./pages/TopicPage"));

function RouteLoading() {
  return (
    <div className="route-loading">
      <div className="route-loading-card">
        <p className="route-loading-eyebrow">Loading dossier</p>
        <h1 className="h4 mb-2">Preparing the page</h1>
        <p className="mb-0 text-muted">
          Rendering the complaint record and supporting navigation.
        </p>
      </div>
    </div>
  );
}

const topicRoutes = topicPages.map((page) => ({
  path: page.slug,
  element: <TopicPage page={page} allPages={topicPages} />,
}));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/about-the-dossier",
    element: <AboutDossier />,
  },
  {
    path: "/full-complaint",
    element: <FullComplaint />,
  },
  ...topicRoutes,
  {
    path: "*",
    element: <NotFound />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Suspense fallback={<RouteLoading />}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
